import { render, staticRenderFns } from "./PartsBookTable.vue?vue&type=template&id=0e8f87c8"
import script from "./PartsBookTable.vue?vue&type=script&lang=ts"
export * from "./PartsBookTable.vue?vue&type=script&lang=ts"
import style0 from "./PartsBookTable.vue?vue&type=style&index=0&id=0e8f87c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports